import type { ReactNode } from 'react';
import { Button } from './Button';

export interface BulkActionBarProps {
  /** The number of selected items. */
  selectedCount: number;
  /** Optionally provide the total number of items — renders "N / M selected" instead of just "N selected". */
  totalCount?: number;
  /** Called when the trailing Cancel button is clicked. */
  onCancel: () => void;
  /** Action buttons (typically `Button`s), rendered between the count and Cancel. */
  children?: ReactNode;
}

// Sticky-adjacent action bar that appears once a Table/list has a selection.
// Compose with Table's TR onClick + a Checkbox column for the selection itself
// (no built-in selection state here — this is presentation only).
export function BulkActionBar({ selectedCount, totalCount, onCancel, children }: BulkActionBarProps): JSX.Element {
  const label = totalCount ? `${selectedCount} / ${totalCount} selected` : `${selectedCount} selected`;
  return (
    <div className="rounded-hairline border border-border bg-card flex flex-wrap items-center gap-3 px-4 py-2">
      <span className="text-sm font-medium text-foreground">{label}</span>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
      <Button variant="ghost" size="sm" className="ml-auto" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  );
}
